import Flickity from 'flickity';
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

var aboutSlider = document.querySelector('.facilities__slider');
var flickityAbout = new Flickity( aboutSlider, {
    wrapAround: true,
});

flickityAbout.on('dragStart', () => flickityAbout.slider.style.pointerEvents = 'none');
flickityAbout.on('dragEnd', () => flickityAbout.slider.style.pointerEvents = 'auto');

const allPhotosBadge = document.querySelector('.facilities__badge');
const $facilitiesGallery = document.getElementById('facilitiesGallery');
const facilitiesGallery = lightGallery($facilitiesGallery, {
    selector: '.facilities__slider-item',
    plugins: [lgZoom, lgThumbnail],
    mobileSettings: true,
});

allPhotosBadge.addEventListener('click', () => {
    facilitiesGallery.openGallery();
})